import GameParameterInterface from '@/models/game/parameters/interface'
import { WaniPanicLotteryParameter } from '@/models/game/parameters/wani-panic'
import { Property } from '@/models/game/property'
import GameExecutorInterface from '@/services/game/executor/executor-interface'
import GameProcessor from '@/services/game/processor'

declare global {
  interface Window {
    GAME: any
  }
}

export default class WaniPanicGameExecutor implements GameExecutorInterface {

  constructor(
    private processor: GameProcessor,
    private property: Property,
    private parameter: GameParameterInterface
  ) { }

  async execute(): Promise<void> {

    const game: any = window.GAME
    const waniPanicParameter: WaniPanicLotteryParameter = this.parameter.createSetOption()

    game.setOption({
      ...waniPanicParameter,
      resource: `${this.property.resourcePath}/`,
      theme: `${this.processor.gameOrganizer}/${this.property.theme}`,
      nextPageUrl: this.processor.makeGameResultUrl(),
    })
    game.setStarted(() => {

      if (!this.processor.playStatusIsStarted) {
        return this.processor.notifyGameStart({})
      }
    })
    game.setCompleted(() => {

      return this.processor.notifyGameComplete()
    })
    game.start()
  }
}
